// @ts-strict-ignore
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    display: 'flex',
    width: '100%',
    maxWidth: '100%',
    borderRadius: '6px',
    alignItems: 'flex-start',
    '& > *:not(:first-child)': {
      marginLeft: '-1px !important',
      borderTopLeftRadius: '0 !important',
      borderBottomLeftRadius: '0 !important',
      '& fieldset': {
        borderTopLeftRadius: '0 !important',
        borderBottomLeftRadius: '0 !important',
      },
    },
    '& > *:not(:last-child)': {
      borderTopRightRadius: '0 !important',
      borderBottomRightRadius: '0 !important',
      '& fieldset': {
        borderTopRightRadius: '0 !important',
        borderBottomRightRadius: '0 !important',
      },
      marginRight: '0 !important',
    },
    '& > *': {
      flexGrow: '1 !important',
      minWidth: 'auto !important',
      position: 'relative',
      zIndex: '2',
    },
    '& .MuiFormControl-root': {
      borderRadius: 'inherit',
      borderTopLeftRadius: 'inherit',
      borderBottomLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
      '& fieldset': {
        borderRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        borderBottomLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        borderBottomRightRadius: 'inherit',
      },
    },
    '& .MuiAutocomplete-root': {
      borderRadius: 'inherit',
      borderTopLeftRadius: 'inherit',
      borderBottomLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
    },
    '& .MuiInputBase-root': {
      minHeight: 40.13,
      borderRadius: 'inherit',
      borderTopLeftRadius: 'inherit',
      borderBottomLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      borderBottomRightRadius: 'inherit',
    },
  },
  error: {
    '& *': {
      borderColor: `${theme.palette.error.main} !important`,
    },
  },
}))
